import React from "react";

import ProjectBlocksContainerEditor from "./blocks/ProjectBlocksContainerEditor";

export default function FeedbackEditor({
                                           feedback,
                                           path,
                                           updateAtPath
                                       }) {

    return (

        <div className="grid grid-cols-2 gap-8">

            <ProjectBlocksContainerEditor
                title="Correct Feedback"
                container={feedback.correct}
                path={[...path, "correct"]}
                updateAtPath={updateAtPath}
            />

            <ProjectBlocksContainerEditor
                title="Incorrect Feedback"
                container={feedback.incorrect}
                path={[...path, "incorrect"]}
                updateAtPath={updateAtPath}
            />

        </div>

    );

}